const state = {
	brandingOptions: [
		{
			option: 'Display Company Logo',
			selected: true,
			index: 0,
			disabled: false,
		},
		{
			option: 'Display Profile Image',
			selected: true,
			index: 1,
			disabled: false,
		},
		{
			option: 'Display Personal Address',
			selected: true,
			index: 2,
			disabled: false,
		},
		{
			option: 'Display Company Address',
			selected: true,
			index: 3,
			disabled: false,
		},
		{
			option: 'Display Full Name',
			selected: true,
			index: 4,
			disabled: false,
		},
		{
			option: 'Display Phone Number',
			selected: true,
			index: 5,
			disabled: false,
		},
		{
			option: 'Display Cell Phone Number',
			selected: true,
			index: 6,
			disabled: false,
		},
		{
			option: 'Display Email Address',
			selected: true,
			index: 7,
			disabled: false,
		},
		{
			option: 'Display Compliance Logo',
			selected: true,
			index: 8,
			disabled: false,
		},
		{
			option: 'Display Partner',
			selected: false,
			index: 9,
			disabled: false,
		},
		{
			option: 'Display Company Website',
			selected: true,
			index: 10,
			disabled: false,
		},
		{
			option: 'Display Blink+ Link',
			selected: true,
			index: 11,
			disabled: false,
		},
		{
			option: 'Display QR Code',
			selected: false,
			index: 12,
			disabled: false,
		},
		{
			option: 'Display Company Name',
			selected: true,
			index: 13,
			disabled: false,
		},
	],
};

const mutations = {
	BRANDING_OPTIONS_TOGGLE(state, item) {
		state.brandingOptions[item.index].selected =
			!state.brandingOptions[item.index].selected;
	},
	BRANDING_OPTIONS_SELECTED(state, item) {
		const index = state.brandingOptions.findIndex(
			(element) => element.option === item.option,
		);
		state.brandingOptions[index].selected = item.selected;
	},
	BRANDING_OPTIONS_DISABLE(state, item) {
		const index = state.brandingOptions.findIndex(
			(element) => element.option === item.option,
		);
		state.brandingOptions[index].disabled = item.disabled;
	},
};

const actions = {
	brandingOptionsToggle(context, item) {
		context.commit('BRANDING_OPTIONS_TOGGLE', item);
	},
	brandingOptionsDisable(context, item) {
		context.commit('BRANDING_OPTIONS_DISABLE', item);
		if (item.disabled) {
			context.commit('BRANDING_OPTIONS_SELECTED', { ...item, selected: false });
		}
	},
};

export default {
	state,
	actions,
	mutations,
};
